import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

export default function IconRadioSelect({
  options,
  value,
  onChange,
  label = "Select Type",
  size = "small",
  variant = "outlined",
  sx = { mt: 1 },
}) {
  return (
    <FormControl sx={sx} size={size} fullWidth variant={variant}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        renderValue={(selectedValue) => {
          const selectedOption = options.find(
            (opt) => opt.value === selectedValue
          );
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {selectedOption?.icon && selectedOption.icon}
              <Typography>{selectedOption?.label}</Typography>
            </div>
          );
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>{option.icon}</ListItemIcon>
                <ListItemText primary={option.label} />
              </div>
              <Radio checked={value === option.value} sx={{ py: 0 }} />
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
